import { get, values } from 'lodash';
import envConfig from '../../static/config';
import UserManagementStore from '../stores/UserManagementStore';

export const isManagePersonalDetailsEnabled = () => {
  return (
    !!values(
      get(envConfig, 'managePersonalDetails.enabledFeatures'),
      {}
    ).filter((value) => value === true).length &&
    !(UserManagementStore.isBusinessUser() || UserManagementStore.isSMEUser())
  );
};
